import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  Snackbar,
  Alert
} from '@mui/material';
import axios from 'axios';
import { API_BASE_URL } from 'src/apiConfig';
import { calculatePoints } from '../reviewProgress/calculatePoints';

// Функција за парсирање стрингова
const parseSolutionString = (solutionString = '') => {
  const regex = /(\d{1,2})([A-Z])/g;
  const parsedTasks = {};
  let match;

  while ((match = regex.exec(solutionString)) !== null) {
    const taskNumber = parseInt(match[1], 10); // Uzmi broj zadatka (može biti 1 ili 2 cifre)
    const answerLetter = match[2]; // Uzmi odgovor A, B, V, G, D
    parsedTasks[taskNumber] = answerLetter; // Poveži broj zadatka sa odgovorom
  }

  return parsedTasks;
};

// Нова компонента за уређивање решења у дијалогу
function GradeSolutionEditorDialog({
  open,
  onClose,
  grade,
  solutionString,
  pointsString,
  studentId,
  fetchSolutions,
  onSave
}) {
  const [parsedTasks, setParsedTasks] = useState(
    parseSolutionString(solutionString)
  );

  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCheckboxChange = (taskNumber, letter) => {
    setParsedTasks((prev) => ({
      ...prev,
      [taskNumber]: prev[taskNumber] === letter ? '' : letter // Izmeni izbor zadatka
    }));
  };

  // const handlePointsChange = (index, value) => {
  //   const newPoints = [...parsedPoints];
  //   newPoints[index] = value;
  //   setParsedPoints(newPoints);
  // };

  const getTaskCountByGrade = (gradeString) => {
    const grade = parseInt(gradeString);
    if (grade === 1 || grade === 2) {
      return 18;
    } else if (grade === 3 || grade === 4) {
      return 24;
    } else {
      return 30;
    }
  };
  const handleSave = async () => {
    try {
      // Generisanje stringa rezultata
      const solutionsString =
        Object.entries(parsedTasks)
          .map(([task, letter]) => `${task}${letter}`)
          .join(':') + ':';

      // Izračunaj poene koristeći tačna rešenja
      const correctSolutions = await fetchSolutions(grade);
      const { totalPoints } = calculatePoints(
        correctSolutions,
        solutionsString,
        true
      );

      // Poziv API-ja za ažuriranje rezultata i poena u jednoj transakciji
      const response = await axios.put(
        `${API_BASE_URL}/api/students.php?id=${studentId}`,
        {
          result: solutionsString,
          points_sum: totalPoints
        }
      );

      if (response.status === 200) {
        setSnackbarOpen(true);
        onSave();
      }
    } catch (error) {
      console.error('Error updating student result and points', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Уреди решења</DialogTitle>
      <DialogContent>
        <Box>
          <Table
            sx={{
              minWidth: 200,
              border: '1px solid #ddd',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              '& .MuiTableCell-root': {
                padding: '2px 4px',
                textAlign: 'center',
                fontSize: '12px',
                lineHeight: '1.2',
                borderBottom: '1px solid #ddd'
              },
              '& .MuiCheckbox-root': {
                padding: '2px',
                transform: 'scale(1.2)',
                color: '#1c75bc',
                '&.Mui-checked': {
                  color: '#1c75bc'
                }
              },
              '& .MuiTableRow-root:nth-of-type(even)': {
                backgroundColor: '#f9f9f9'
              }
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>Број</TableCell>
                {['A', 'Б', 'В', 'Г', 'Д'].map((letter) => (
                  <TableCell key={letter}>{letter}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from(
                { length: getTaskCountByGrade(grade) },
                (_, i) => i + 1
              ).map((taskNumber) => (
                <TableRow key={taskNumber}>
                  <TableCell>{taskNumber}.</TableCell>
                  {['A', 'B', 'V', 'G', 'D'].map((letter) => (
                    <TableCell key={letter}>
                      <Checkbox
                        size="small"
                        checked={parsedTasks[taskNumber] === letter} // Provera tačnog odgovora
                        onChange={() =>
                          handleCheckboxChange(taskNumber, letter)
                        }
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          sx={{
            backgroundColor: '#1c75bc',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#155a8a'
            },
            padding: '6px 16px',
            borderRadius: '8px',
            fontSize: '14px'
          }}
        >
          Сачувај
        </Button>
        <Button
          onClick={onClose}
          variant="outlined"
          color="secondary"
          sx={{
            borderColor: '#ccc',
            color: '#666',
            '&:hover': {
              borderColor: '#999'
            },
            padding: '6px 16px',
            borderRadius: '8px',
            fontSize: '14px'
          }}
        >
          Откажи
        </Button>
      </DialogActions>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="success">
          Успешно ажурирано!
        </Alert>
      </Snackbar>
    </Dialog>
  );
}

export default GradeSolutionEditorDialog;
